import React, { useEffect, useState } from "react";
import { Table, Button, Modal, Form, Input, message, Popconfirm } from "antd";
import AdminCategoryService from "../../../Modules/Services/admin.categories.service";

const ManageCategories = () => {
  const [categories, setCategories] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [editingCategory, setEditingCategory] = useState(null);
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(true);

  const fetchCategories = async () => {
    try {
      setLoading(true);
      const fetchedCategories = await AdminCategoryService.getAllCategories();
      setCategories(fetchedCategories);
    } catch (error) {
      message.error("Не удалось загрузить категории.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  useEffect(() => {
    if (editingCategory) {
      form.setFieldsValue({ name: editingCategory.name });
    } else {
      form.resetFields();
    }
  }, [editingCategory, form]);

  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      if (editingCategory) {
        await AdminCategoryService.updateCategory(
          editingCategory.id,
          values.name
        );
        message.success("Категория успешно обновлена!");
      } else {
        await AdminCategoryService.createCategory(values.name);
        message.success("Категория успешно создана!");
      }
      setIsModalVisible(false);
      setEditingCategory(null);
      fetchCategories();
    } catch (error) {
      message.error("Произошла ошибка.");
    }
  };

  const handleDelete = async (id) => {
    try {
      await AdminCategoryService.deleteCategory(id);
      message.success("Категория успешно удалена!");
      fetchCategories();
    } catch (error) {
      message.error("Не удалось удалить категорию.");
    }
  };

  const columns = [
    { title: "ID", dataIndex: "id", key: "id" },
    { title: "Название", dataIndex: "name", key: "name" },
    {
      title: "Действия",
      key: "actions",
      render: (text, record) => (
        <span>
          <Button
            type="primary"
            style={{ marginRight: 8 }}
            onClick={() => {
              setEditingCategory(record);
              setIsModalVisible(true);
            }}
          >
            Редактировать
          </Button>
          <Popconfirm
            title="Вы уверены, что хотите удалить эту категорию?"
            onConfirm={() => handleDelete(record.id)}
          >
            <Button type="primary" danger>
              Удалить
            </Button>
          </Popconfirm>
        </span>
      ),
    },
  ];

  return (
    <div>
      <Button
        type="primary"
        onClick={() => {
          setEditingCategory(null);
          setIsModalVisible(true);
        }}
        style={{ marginBottom: 16 }}
      >
        Создать категорию
      </Button>
      <Table
        dataSource={categories}
        columns={columns}
        rowKey="id"
        loading={loading}
      />

      <Modal
        title={
          editingCategory
            ? "Редактировать категорию"
            : "Создать новую категорию"
        }
        visible={isModalVisible}
        onOk={handleOk}
        onCancel={() => {
          setIsModalVisible(false);
          setEditingCategory(null);
        }}
      >
        <Form form={form} layout="vertical">
          <Form.Item
            name="name"
            label="Название категории"
            rules={[
              {
                required: true,
                message: "Пожалуйста, введите название категории!",
              },
            ]}
          >
            <Input />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default ManageCategories;
